<template>
    <div>
        <div  v-for="(classPlan,index) in datax.classPlans" :key="index"  draggable="true">
            <div class="classPlan" v-on:mousedown="gakki(classPlan.id)"  @click="handleUpdateClassPlan(classPlan.id,classPlan.teacher_id,classPlan.start_time,classPlan.end_time)">
                <div align="center" style="padding-top: 3px">老师：{{classPlan.teacherName}}</div>
                <div align="center" style="margin-top: 3px">上课时间：{{classPlan.start_time}}-{{classPlan.end_time}}</div>
            </div>
        </div>
        <component @closeModal="modal=''" :datax="form" v-bind:is="modal"></component>
    </div>
</template>

<script>
    import UpdateClassPlan from './UpdateClassPlan'
    import StoreClassPlan from './StoreClassPlan'
    export default {
        name: "UpdateMoreClassPlan",
        data() {
            return {
                button_loading: false,
                loading: true,
                modal: '',
                form:{},
                son:{},
            }
        },
        props: {
            datax:{}
        },
        components: {
            'UpdateClassPlan': UpdateClassPlan,
            'StoreClassPlan': StoreClassPlan,
        },
        created() {
            this.parentInfo = this.$parent.$parent.$parent.$parent;
        },
        methods: {
            handleMsgToParent:function(id){
                this.$emit("listenToChildEvent",id)
            },
            gakki(classPlan_id){
                this.handleMsgToParent(classPlan_id);
            },
            handleUpdateClassPlan(classPlan_id,teacher_id,start_time,end_time){
                this.parentInfo.form.teacher_id=teacher_id;
                this.parentInfo.form.start_time=start_time;
                this.parentInfo.form.end_time=end_time;
                this.parentInfo.form.id=classPlan_id;
                this.parentInfo.form.status=true;
                this.parentInfo.modal = 'UpdateClassPlan'
            },
            handleStoreClassPlan(){
                this.parentInfo.form.date = this.datax.classPlans[0].date;
                this.parentInfo.form.class_id = this.datax.classPlans[0].class_id;
                this.parentInfo.modal = 'StoreClassPlan'
            },
            closeModal() {
                this.$emit('closeModal')
            },
        }
    }
</script>

<style scoped>
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 99999;
    }

    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }

    .modal-header {
        font-size: 12px;
    }

    .modal-title {
        margin: 0;
        line-height: 1.5;
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }

    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }

    .modal .close:hover {
        opacity: .5;
    }
    .classPlan{
        background: rgba(255,235,221,0.8);
        color:rgba(211,122,63,1);
        margin-top: 5px;
        margin-bottom: 10px;
        height: 50px;
        width: 225px;
        margin-left: 40px;
        border-radius:5px
    }
</style>
